import axios from "axios";

type ApiErrorData = {
  data?: unknown;
  error?: unknown;
  error_description?: unknown;
  errors?: unknown;
  message?: unknown;
};

const asApiErrorData = (value: unknown): ApiErrorData | undefined =>
  typeof value === "object" && value !== null
    ? (value as ApiErrorData)
    : undefined;

const nonEmptyString = (value: unknown): string | undefined =>
  typeof value === "string" && value.trim() ? value.trim() : undefined;

const getMessageFromData = (value: unknown): string | undefined => {
  const data = asApiErrorData(value);

  if (!data) return nonEmptyString(value);

  const directMessage =
    nonEmptyString(data.message) ||
    nonEmptyString(data.error_description) ||
    nonEmptyString(data.error);

  if (directMessage) return directMessage;

  const nestedError = asApiErrorData(data.error);
  const nestedErrorMessage = nestedError && nonEmptyString(nestedError.message);

  if (nestedErrorMessage) return nestedErrorMessage;

  if (Array.isArray(data.errors)) {
    for (const item of data.errors) {
      const itemMessage =
        nonEmptyString(item) ||
        nonEmptyString(asApiErrorData(item)?.message);

      if (itemMessage) return itemMessage;
    }
  }

  // Some API endpoints wrap their error body in a second `data` object:
  // { data: { code, status, message, timestamp } }.
  const nestedData = asApiErrorData(data.data);
  if (nestedData && nestedData !== data) {
    return getMessageFromData(nestedData);
  }

  return undefined;
};

export function getApiErrorMessage(
  error: unknown,
  fallback = "Something went wrong"
) {

  if (axios.isAxiosError(error)) {
    return getMessageFromData(error.response?.data) || error.message || fallback;
  }

  if (error instanceof Error) return error.message || fallback;

  return fallback;
}
